import React from 'react';
import { Spinner } from 'react-bootstrap';

interface LoadingSpinnerProps {
  fullscreen?: boolean;
  size?: 'sm' | 'md' | 'lg';
  text?: string;
  className?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  fullscreen = false, 
  size = 'md', 
  text = 'Loading...', 
  className = '' 
}) => {
  // Determine spinner size
  const spinnerSize = size === 'sm' ? '' : size === 'lg' ? 'spinner-border-lg' : '';
  
  if (fullscreen) {
    return (
      <div className="loading-screen d-flex flex-column align-items-center justify-content-center position-fixed top-0 start-0 w-100 h-100 bg-white bg-opacity-75" style={{ zIndex: 1090 }}>
        <Spinner animation="border" role="status" className={`${spinnerSize} text-primary mb-2 ${className}`}>
          <span className="visually-hidden">Loading...</span>
        </Spinner>
        {text && <p className="text-primary">{text}</p>}
      </div>
    );
  }
  
  return (
    <div className={`d-flex flex-column align-items-center justify-content-center py-3 ${className}`}>
      <Spinner animation="border" role="status" className={`${spinnerSize} text-primary mb-2`}>
        <span className="visually-hidden">Loading...</span>
      </Spinner>
      {text && <p className="text-primary">{text}</p>}
    </div>
  );
};

export default LoadingSpinner;
